import { z } from "zod";

// Vault created event
const VaultCreatedEventSchema = z.object({
  type: z.literal("vault.created"),
  data: z.object({
    owner: z.string().optional(),
    strategyId: z.string().optional(),
    vaultAddress: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
    chainId: z.number().int().positive(),
    timestamp: z.string().datetime(),
  }),
});

export const VaultEventSchema = z.discriminatedUnion("type", [
  VaultCreatedEventSchema,
]);

export type VaultEvent = z.infer<typeof VaultEventSchema>;
